import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { GetIntegrationProductListRequestDto } from "../dtos/get-integration-product-list-request-dto";
import type { GetProductDetailRequestDto } from "../dtos/get-product-detail-request-dto";
import type { GetProductDraftDetailRequestDto } from "../dtos/get-product-draft-detail-request-dto";
import type { GetProductListRequestDto } from "../dtos/get-product-list-request-dto";
import type { GetProductVariantListRequestDto } from "../dtos/get-product-variant-list-request-dto";

export const ProductQueryKeys = createQueryKeys("product", {
  getProductList: ({
    q,
    page,
    limit,
    category_id,
    sort,
    product_status
  }: GetProductListRequestDto) => [
    q,
    page,
    limit,
    category_id,
    sort,
    product_status
  ],

  getProductListInfinite: ({
    q,
    limit,
    category_id,
    sort,
    product_status
  }: Omit<GetProductListRequestDto, "page">) => [
    q,
    limit,
    category_id,
    sort,
    product_status
  ],

  getProductDetail: ({ slug }: GetProductDetailRequestDto) => [slug],

  getProductDraftList: ({
    q,
    page,
    limit,
    category_id,
    sort,
    product_status
  }: GetProductListRequestDto) => [
    q,
    page,
    limit,
    category_id,
    sort,
    product_status
  ],

  getProductDraftDetail: ({ id }: GetProductDraftDetailRequestDto) => [id],

  getProductTypeList: () => ["product-type-list"],

  getProductFeeTierList: () => ["product-fee-tier-list"],

  getIndustryCategoryList: () => ["industry-category-list"],

  getProductAutomationDetail: ({ productId }: { productId: string }) => [
    productId
  ],

  getProductVariantList: ({
    productPackageId
  }: GetProductVariantListRequestDto) => [productPackageId],

  getIntegrationProductList: ({
    q,
    page,
    limit
  }: GetIntegrationProductListRequestDto) => [q, page, limit],

  getCrmProductDetail: ({ productId }: { productId: string }) => [productId],
  getCrmHierarchy: ({ productId }: { productId: string }) => [productId],

  getBclProductDetail: ({ productId }: { productId: string }) => [productId],

  getErfinaProductDetail: ({ productId }: { productId: string }) => [productId]
});
